import { makeStyles } from "tss-react/mui"
import { Grid, Link, Typography } from "@mui/material"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const PROD_LINK = "https://app.facilitynet.dk"

const useStyles = makeStyles()((theme) => ({
    container: {
        background: theme.palette.tailwind.rose[600],
        color: theme.palette.common.white,
        textAlign: "center",
        padding: "1.25rem",
    },
    infoIcon: {
        color: theme.palette.common.white,
    },
}))
export function QaEnvWarning() {
    const { classes } = useStyles()

    return (
        <Grid
            container
            className={classes.container}
            alignItems="center"
            justifyContent="center"
            flexWrap="nowrap"
            gap=".5rem"
        >
            <FontAwesomeIcon icon={faInfoCircle} className={classes.infoIcon} />
            <Typography variant="body1">
                <LocalizedStrict id="qa-env-warning-part-one">
                    <>You are in QA environment. This is not intended for customers. Please use</>
                </LocalizedStrict>{" "}
                <Link href={PROD_LINK} color="inherit">
                    {PROD_LINK}
                </Link>{" "}
                <LocalizedStrict id="qa-env-warning-part-two">
                    <>instead.</>
                </LocalizedStrict>
            </Typography>
        </Grid>
    )
}
